<script>
import { getLanguage, isSpeakpalDomain } from './util/index'
import CookiesModal from './components/Modal/CookiesModal.vue'
import { globalConfig, userInfo, setCookie } from './util/globalStore'
import { addOnlineTime, getOrgInfo } from './api/index'


//局部组件注册	
export default {
	components: {
		CookiesModal
	},

	data() {
		return {
			config: globalConfig(),
			isSpeakpalDomain: isSpeakpalDomain(),
			user: userInfo()
		}
	},

	methods: {
		onClickLanguageChange(e) {
			if (e == 0) {
				this.$i18n.locale = "en"
			} else if (e == 1) {
				this.$i18n.locale = "zh_tw"
			} else if (e == 2) {
				this.$i18n.locale = "ja"
			} else if (e == 3) {
				this.$i18n.locale = "ko"
			} else {
				this.$i18n.locale = "zh"
			}
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		},

		handleMenuSelect(e) {
			console.log(e);
		},

		// onClickCookiesModal(accept) {
		// 	if (accept) {
		// 		this.insertJS()
		// 	}
		// },

		insertJS() {
			return
			//引用类
			let srcList = ['https://accounts.google.com/gsi/client', 'https://www.googletagmanager.com/gtag/js?id=AW-16575049816', 'https://www.googletagmanager.com/gtag/js?id=G-36CRTTMDKQ']
			srcList.forEach(element => {
				const script = document.createElement('script');
				script.src = element;
				document.getElementById('footer').appendChild(script);
			});
			//内容
			let dataList = ["window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag('js', new Date()); gtag('config', 'AW-16575049816');", "window.dataLayer = window.dataLayer || [];  function gtag(){dataLayer.push(arguments);}  gtag('js', new Date());  gtag('config', 'G-36CRTTMDKQ');"]
			dataList.forEach(element => {
				let script = document.createElement("script");
				script.innerHTML = element;
				document.getElementById('footer').appendChild(script);
			})
		},

		insertMetaJS() {
			let script = document.createElement("script");
			script.innerHTML = `
			!function(f,b,e,v,n,t,s)
        	{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
        	fbq('init', '644575994552198');
        	fbq('track', 'PageView');
				`;
			document.getElementById('footer').appendChild(script);

			let script2 = document.createElement("noscript");
			script2.innerHTML = `
			<img  alt="EnglishPal" height="1" width="1" style="display:none"
			src="https://www.facebook.com/tr?id=644575994552198&ev=PageView&noscript=1"
			/>
			`;
			document.getElementById('footer').appendChild(script2);
		},

		changeGoogleADJS() {
			return
			let user = userInfo()
			var element = document.getElementById("myGoogleAd");
			if (element) {
				if (!user.isLogin || !user.is_load_google_ads) {
					element.parentNode.removeChild(element);
				}
			} else if (user.isLogin && user.is_load_google_ads) {
				var script = document.createElement('script');
				// 设置 script 元素的属性
				script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8969053430317301";
				script.async = true;
				script.crossOrigin = "anonymous";
				// 为 script 元素设置 id
				script.id = "myGoogleAd";
				// 将 script 元素插入到文档的头部或其他合适的位置
				document.head.appendChild(script);
			}
		},

		screenWake() {
			//屏幕常亮
			if ('wakeLock' in navigator) {
				navigator.wakeLock.request("screen").then(res => {
					console.log('✅ 已保持屏幕常亮');
				}).catch(error => {
					// console.error("常亮失败", error)
				})
			} else {
				// console.error("常亮失败，浏览器不支持")
			}
		},

		setVhUnit() {
  			const vh = window.innerHeight * 0.01;
  			document.documentElement.style.setProperty('--vh', `${vh}px`);
		},

		addTime() {
			let user = userInfo()
			if (user.isLogin)  {
				addOnlineTime({}).then(res => {

				})
			}
		},
	},
	mounted(ops) {
		var config = globalConfig()
		const params = new URLSearchParams(window.location.search);
		if (params.has('org')) {
			const orgValue = params.get('org');
			getOrgInfo({
				org_id: orgValue
			}).then(data => {
				config.isFromOrg = true
				config.orgInfo = data
				config.orgInfo.logo_name = data.logo_name
				if (config.themeColor) {
					//设置主题色
					this.$nextTick(() => {
						document.documentElement.style.setProperty('--main-color', config.themeColor);
					})
				}
				document.title = config.orgInfo.logo_name
			})
		} else if (this.isSpeakpalDomain) {
			//先读用户信息
			if (this.user.isLogin && this.user.org_user_type == 1) {
				config.isFromOrg = true
				if (!config.orgInfo) {
					config.orgInfo = {}
				}
				config.orgInfo.logo_name = this.user.logo_info.name
				config.orgInfo.logo_url = this.user.logo_info.url
			} else if (config.orgInfo && config.orgInfo.logo_name) {
				config.isFromOrg = true
				//有org链接的缓存，读缓存
				if (config.themeColor) {
					console.log("config.themeColor", config.themeColor)
					//设置主题色
					this.$nextTick(() => {
						document.documentElement.style.setProperty('--main-color', config.themeColor);
					})
				}
				document.title = config.orgInfo.logo_name
			} else {
				//没有缓存，也没有org，默认自己用户，读用户信息,默认值即可
				config.isFromOrg = false
			}
		} else {
			//第三方绑定域名，传域名
			getOrgInfo({
				host: window.location.hostname
			}).then(data => {
				config.isFromOrg = true
				config.orgInfo = data
				config.orgInfo.logo_name = window.location.hostname
				if (config.themeColor) {
					//设置主题色
					this.$nextTick(() => {
						document.documentElement.style.setProperty('--main-color', config.themeColor);
					})
				}
				document.title = config.orgInfo.logo_name
			})
		}



		let browserLanguage = getLanguage();
		this.$i18n.locale = browserLanguage.replace(/-/g, "_");
		if (this.config.channel == "metaweb") {
			console.log("metaweb")
			this.insertMetaJS()
		}
		//
		let user = userInfo()
		if (user.themeColor) {
			//设置主题色
			document.documentElement.style.setProperty('--main-color', user.themeColor);
		}
		if (user.isLogin) {
			setCookie("hitalk_is_login", "1")
			this.changeGoogleADJS()
		} else {
			setCookie("hitalk_is_login", "0")
			this.changeGoogleADJS()
		}
		//监听用户信息
		user.$subscribe((mutation, state) => {
			if (state.id > 0 && state.id != 9999 && state.login_access_token != '') {
				setCookie("hitalk_is_login", "1")
			} else {
				setCookie("hitalk_is_login", "0")
			}
			this.changeGoogleADJS()
		})

		//屏蔽双击
		var lastTouchEnd = 0;
		document.documentElement.addEventListener('touchend', function (event) {
			var now = Date.now();
			if (now - lastTouchEnd <= 300) {
				event.preventDefault();
			}
			lastTouchEnd = now;
		}, false);
		//屏幕常亮
		this.screenWake()

		//计算屏幕高度
		this.setVhUnit();
		window.addEventListener('resize', this.setVhUnit);
		//增加时间
		setInterval(() => {
			this.addTime()
		}, 10000);
	}
}
</script>


<template>
	<div class="content-area">
		<div class="content-body">
			<!-- <router-view /> -->
			<router-view v-slot="{ Component }">
				<keep-alive>
					<component :is="Component" v-if="$route.meta.keepAlive" />
				</keep-alive>
				<component :is="Component" v-if="!$route.meta.keepAlive" />
			</router-view>
		</div>
	</div>
</template>

<style>
* {
	box-sizing: border-box;
}

:root {
  --vh: 1vh;
  --main-color: #2563EB;
}



html {
	font-size: 100px;
	touch-action: manipulation;
	-ms-touch-action: manipulation;
}

@media only screen and (max-width: 768px) {
	html {
		font-size: 80px;
	}

	body {
		font-size: 14px;
	}
}

body {
	margin: 0;
	font-size: 16px;
	background-color: #fff;
	--safe-area-inset-top: 0px;
	--safe-area-inset-bottom: 0px;
	--safe-area-inset-top: env(safe-area-inset-top);
	--safe-area-inset-bottom: env(safe-area-inset-bottom);
	-webkit-text-size-adjust: 100% !important;
	text-size-adjust: 100% !important;
	-moz-text-size-adjust: 100% !important;
	/* 导航栏高度 */
	--nav-height: 0.7rem;
	--nav-z-index: 999;
	--nav-pop-z-index: 1000;
	/* 除去导航栏高度 */
	--content-fill-height: calc(var(--vh, 1vh) * 100 - var(--nav-height));
	--main-disable-color: rgba(255, 206, 49, 0.6);
	touch-callout: none;
	-webkit-touch-callout: none;
}

.full-height {
  height: calc(var(--vh, 1vh) * 100);
}


.full-content-height {
  height: calc(var(--vh, 1vh) * 100 - var(--nav-height));
}


/* 长按放大镜 */
*:not(input):not(textarea) {
	-webkit-user-select: none
}

#app {
	font-family: -apple-system, system-ui, Arial, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Helvetica Neue", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Avenir, Helvetica, sans-serif;
	line-height: 1.4;
	color: #2c3e50;
}

.disable-select {
	touch-callout: none;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* 内容 */
.container {
	min-height: var(--content-fill-height);
	display: flex;
	flex-direction: column;
	align-items: center;
	/*margin-top: var(--nav-height);*/
}

.content-area {
	display: flex;
	/*margin-top: var(--nav-height);*/
}

.left-menu {
	width: 3rem;
	background-color: red;
}

.content-body {
	flex: 1;
}

a {
	text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	margin-top: 0;
	margin-bottom: 0;
}

h2 {
	font-size: 0.22rem;
	color: #000000;
	font-weight: bold;
}

h3 {
	font-size: 0.20rem;
	color: #000000;
	font-weight: bold;
}

h4 {
	font-size: 0.18rem;
	color: #000000;
	font-weight: normal;
}

h5 {
	font-size: 0.16rem;
	color: #000000;
	font-weight: normal;
}

.gray {
	-webkit-filter: grayscale(100%);
	-moz-filter: grayscale(100%);
	-ms-filter: grayscale(100%);
	-o-filter: grayscale(100%);
	filter: grayscale(100%);
	filter: gray;
}

.scaleAnimation {
	animation: scaleAnimation 1.5s ease-in-out infinite;
}

.midScaleAnimation {
	animation: scaleAnimation 2.0s ease-in-out infinite;
}

.slowScaleAnimation {
	animation: slowScaleAnimation 2.0s ease-in-out infinite;
}

@keyframes scaleAnimation {
	0% {
		transform: scale(1);
	}

	50% {
		transform: scale(1.2);
	}

	100% {
		transform: scale(1);
	}
}

@keyframes slowScaleAnimation {
	0% {
		transform: scale(1);
	}

	50% {
		transform: scale(1.1);
	}

	100% {
		transform: scale(1);
	}
}

/* 手机版 */
@media screen and (max-width: 600px) {}
</style>
